<template>
  <div class="container">
    <div v-for="m in matters" class="columns">
      <div class="column col-5">
        <router-link :to="'/matters/' + m._id">{{m.mattername}}</router-link>
      </div>
      <div class="column col-5">
        Due {{new Date(m.due).toDateString()}}
      </div>
      <div class="column col-2">
        <button class="btn" @click="del(m)">
          <i class="fa fa-trash-o" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'clientMatters',
  props: ['user'],
  data () {
    return {
      matters: []
    }
  },
  created () {
    this.getMatters()
  },
  methods: {
    getMatters () {
      axios.get('/api/matters/clientmatterlist/' + this.user._id)
      .then(res => {
        if (res.status === 200) {
          this.matters = res.data
        }
      })
      .catch(e => { console.log(e.response.data) })
    },
    del (matter) {
      axios.post('/api/matters/delete/' + matter._id)
      .then(res => {
        if (res.status === 200) {
          this.getMatters()
        }
      })
      .catch(e => { console.log(e.response.data) })
    }
  }
}
</script>



// WEBPACK FOOTER //
// clientMatters.vue?2266f315